export default {
  inserted(el, binding) {
    const BACKDROP_ID = 'backdrop-zoom'
    const { imgSource } = binding.value
    const url = (imgSource && imgSource.xLarge) || imgSource
    const imgEl = new Image()
    let closeEl = null
    let backdropZoomEl = document.getElementById(BACKDROP_ID)

    if (!backdropZoomEl) {
      backdropZoomEl = document.createElement('div')
      closeEl = document.createElement('span')
      closeEl.classList.add('close')

      backdropZoomEl.id = BACKDROP_ID
      backdropZoomEl.classList.add(BACKDROP_ID)

      backdropZoomEl.addEventListener('click', (e) => {
        if (e.target.tagName !== 'IMG') {
          backdropZoomEl.classList.remove('show')
        }
      })

      backdropZoomEl.appendChild(closeEl)
      backdropZoomEl.appendChild(imgEl)
      document.body.appendChild(backdropZoomEl)
    }

    el.addEventListener('click', () => {
      if (backdropZoomEl) {
        const imgZoomEl = backdropZoomEl.querySelector('img')

        if (imgZoomEl) {
          imgZoomEl.src = url
          backdropZoomEl.classList.add('show')
        }
      }
    })
  },
}
